export default __webpack_public_path__ + "7bc564680d1477aedaff5cf60cfa1ac0.svg";